import { ReactNode } from 'react'

import yup from '~/utils/validationMessages'

import { UserConsentTypeEnum } from '~/app/generated/graphql'
import { DangerousTranslate } from '~/components/DangerousTranslate'
import { GT } from '~/lib/gt'

import { errors } from '../LoginModal/errors'
import { validationFields } from '../LoginModal/LoginModalUtils'

export const newPasswordSchema = yup
  .string()
  .test({
    name: 'no_spaces',
    message: errors.validation.mixed.no_spaces,
    test: value => (value ? !value.match(/\s/g) : true),
  })
  .matches(/^(?=.*[a-z])(?=.*[A-Z]).*$/, errors.validation.mixed.mixed_case)
  .min(8, () => errors.validation.min_length(8))

export const registerSchema = yup.object().shape({
  firstName: validationFields.firstName.optional(),
  lastName: validationFields.lastName.optional(),
  phoneNumber: validationFields.phoneNumber.required(),
  email: validationFields.email.optional(),
  password: newPasswordSchema.required(),
  marketingConsentAccepted: yup.boolean(),
  regulationConsentAccepted: yup.boolean().oneOf([true]),
})

export const registerNowText = [
  'Invite your loved ones!',
  'Book your favorite menu. Discover new restaurants.',
  'Thousands of signature dishes, hundreds of best restaurants awaits for you!',
  'Benefit from discounts and offers thanks to RestaurantClub friends.',
]

type GetConsentsArgs = {
  label: ReactNode
  showMore: ReactNode
}

export const getConsents = (gt: GT, { label, showMore }: GetConsentsArgs) => [
  {
    name: 'regulationConsentAccepted' as const,
    label: (
      <DangerousTranslate
        text={gt.tp(
          'RegisterForm',
          '* I accept the <a href="{{ regulationsLink }}" target="_blank">Terms and Conditions</a> and have read the <a href="{{ privacyPolicyLink }}" target="_blank">Privacy Policy</a>',
          {
            regulationsLink: '/regulations',
            privacyPolicyLink: '/privacy-policy',
          }
        )}
      />
    ),
    consentType: UserConsentTypeEnum.RcRegulationConsent,
  },
  {
    name: 'marketingConsentAccepted' as const,
    label,
    showMore,
    consentType: UserConsentTypeEnum.MarketingConsent,
  },
]
